import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import _ from 'lodash';

import {
  getAccountProposalSelector,
  isExpandedQuotesSelector,
  setIsExpandedQuotes,
} from 'src/store/proposals';
import {
  getPetQuotes,
  isLoadingPetInsuranceDataSelector,
  petInsuranceDataSelector,
} from 'src/store/pet';

import { InstantPetQuote } from '../instantPetQuote/InstantPetQuote';
import { PetQuoteCard } from '../petQuoteCard/PetQuoteCard';
import { Button, EmptyField, LogoLoader, LoaderWrapper, Modal } from 'src/components';

import { ExpandMoreOutlined } from '@mui/icons-material';
import classes from './petQuotes.module.scss';

export const PetQuotes = (props) => {
  const { isIssuer = false } = props;

  const dispatch = useDispatch();
  const params = useParams();
  const { pathname } = useLocation();

  const isExpandedQuotes = useSelector(isExpandedQuotesSelector);

  const accountProposalData = useSelector(getAccountProposalSelector);
  const petInsuranceData = useSelector(petInsuranceDataSelector);
  const isLoadingPetInsuranceData = useSelector(isLoadingPetInsuranceDataSelector);
  const accountId = params?.id ? params?.id : accountProposalData?.account_id;
  const proposalId = params?.proposalId ? params?.proposalId : accountProposalData?.id;
  const readOnlyToken = params?.token ? params?.token : '';
  const isReadOnlyMode = pathname.includes('/read-only');

  const [isExpandedQuote, setIsExpandedQuote] = useState(true);
  const [isCreateQuote, setIsCreateQuote] = useState(false);

  const [selectedQuote, setSelectedQuote] = useState({});
  const [selectedPlans, setSelectedPlans] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(accountId) && !_.isEmpty(proposalId)) {
      dispatch(getPetQuotes({ accountId, proposalId, read_token: readOnlyToken }));
    }
    dispatch(setIsExpandedQuotes(true));
  }, [dispatch, accountId, proposalId, readOnlyToken]);

  useEffect(() => {
    setIsExpandedQuote(isExpandedQuotes);
  }, [isExpandedQuotes]);

  const onExapandQuotes = useCallback(() => {
    setIsExpandedQuote((prev) => !prev);
  }, []);

  const handleShowModal = useCallback(() => {
    setIsCreateQuote((prev) => !prev);
    setSelectedQuote({});
    setSelectedPlans([]);
  }, []);

  const onClickEdit = useCallback(
    (quote, plans) => () => {
      setSelectedQuote(quote);
      setSelectedPlans(plans);
      setIsCreateQuote(true);
    },
    [],
  );

  return (
    <>
      {isCreateQuote && (
        <Modal type="fit" closeButtonType="inside" onClose={handleShowModal}>
          <InstantPetQuote
            onClose={handleShowModal}
            selectedEditQuote={selectedQuote}
            selectedEditPlans={selectedPlans}
          />
        </Modal>
      )}

      <div className={classes.PetQuotes}>
        <Accordion expanded={isExpandedQuote} onChange={onExapandQuotes}>
          <AccordionSummary
            expandIcon={<ExpandMoreOutlined />}
            aria-controls="panel1-content"
            id="panel1-header"
            className={classes.PetQuotesTitle}
          >
            Pet Quotes
          </AccordionSummary>
          <AccordionDetails>
            {isLoadingPetInsuranceData ? (
              <LoaderWrapper>
                <LogoLoader />
              </LoaderWrapper>
            ) : (
              <>
                {petInsuranceData?.quotes?.length ? (
                  petInsuranceData?.quotes?.map((item) => (
                    <PetQuoteCard
                      key={item.id}
                      quote={item}
                      onClickEdit={onClickEdit}
                      isIssuer={isIssuer}
                    />
                  ))
                ) : (
                  <EmptyField title="No instant pet quotes created yet." />
                )}
              </>
            )}

            {!isReadOnlyMode && !isIssuer && (
              <div className={classes.PetQuotesHeaderButtons}>
                <Button title="Instant Quote" type="primary" onClick={handleShowModal} />
              </div>
            )}
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};
